export const SourceMapGenerator = require('./source-map-generator').SourceMapGenerator;
export const SourceMapConsumer = require('./source-map-consumer').SourceMapConsumer;
export const SourceNode = require('./source-node').SourceNode;
